import React from "react";
import { Paper } from "@mui/material";
import Navbar from "../components/common/navbar";
import Footer from "../components/common/footer";

const AboutUsPage = () => {
  return (
    <>
      <Navbar />
      <div className="my-0">
        <Paper elevation={3}>
          <div className="py-5 bg-about">
            <div className="text-center">
              <h2 className="about-header">
                {" "}
                Purbanchal Educational Welfare Society (PEWS){" "}
              </h2>
            </div>
          </div>

          <div className="p-5">
            <div className="text-center">
              <h2> PEWS AT A GLANCE </h2>
            </div>
            <div className="p-4 ">
              <div className="row justify-content-center text-justify">
                <p className="text-justify">
                  Purbanchal Educational Welfare Society (PEWS) Group of
                  Institutions came into being in the year 2003 as the fruit of
                  untiring labour put fourth by a few educationally enthusiastic
                  personalities of greater Guwahati, who had joined hands
                  together to get PEWS registered under societies Registration
                  Act XXI of 1860 and then marched forward with exemplary high
                  spirit in establishing several educational institutions as its
                  milestones on the path of its academic journey. Always guided
                  by the slogan “With a Solution for a Brighter Tomorrow”, PEWS,
                  since then has had no looking back in its zeal for spreading
                  most timely needed professional and vocational courses in the
                  North Eastern Region, focusing at Guwahati, which is the hub
                  of all modern activities for the region.
                  <br />
                  <br />
                  Its unit colleges namely, College of Physiotherapy & Medical
                  Sciences (MPT/BPT), CPMS College of Nursing (M.Sc Nursing/B.Sc
                  Nursing/P.B.B.Sc Nursing), CPMS School of Nursing (GNM/ANM)
                  and PEWS College of Paramedical Sciences (BMLT/ DMLT/
                  B.OPTOMETRY/ Diploma in OT Technician) bear testimony of the
                  ardent dedication of its founder members. This has not only
                  satisfied the dire need of such programes among the youth
                  community but also have broadened the academic horizon of the
                  region, and thereby creating employment opportunity to a large
                  section of the Society, to serve the humanity by dint of
                  skilled tactics & knowledge which in turn promises them to
                  live life to the fullest with self respect and self sustenance
                </p>
              </div>
            </div>
          </div>

          <div className="p-5">
            <div className="text-center">
              <h2> MISSION AND GOAL </h2>
            </div>
            <div className="p-4">
              <div className="row justify-content-center">
                <p className="text-justify">
                  I. To provide a solution for a brighter tomorrow by imparting
                  quality education to the youths of North East in the field of
                  professional courses.
                  <br />
                  II. To provide excellent infrastructure to the students so
                  that they can carve a niche of their own in the field of
                  professional courses.
                  <br />
                  III. Enhance purposeful education with “Human Values” and
                  social responsibilities to promote a rational outlook towards
                  the society.
                  <br />
                  IV. Achieve excellence in academic discipline, research and
                  extension activities through emphasis on “Quality In Every
                  Activity”
                  <br />
                  V. To cater, facilitate, nurture and motivate students so as
                  to boost their confidence and knowledge for becoming a better
                  human being. Hence make maximum possible contribution for the
                  better well being of the society as a whole.
                </p>
              </div>
            </div>
          </div>

          <div className="p-5">
            <div className="text-center">
              <h2> WHY CHOOSE US?</h2>
            </div>
            <div className="p-4">
              <div className="row justify-content-center">
                <p className="text-justify">
                  Pews Group of Institutions , Guwahati , the pioneer and
                  leading institute of north east since 2003 offering courses on
                  BPT, MPT, B.Sc. Nursing, MSc Nursing, Post Basic B.Sc.
                  Nursing, GNM, ANM, BMLT, DMLT, B. OPTOMETRY and Diploma in OT
                  Technician Technology etc.
                  <br />
                  <br />
                  Pews Group of Institutions is affiliated to Govt University
                  i.e Srimanta Sankaradeva University of Health Sciences,
                  Recognized by Indian Nursing council (INC) and Indian
                  Association of Physiotherapists (IAP) and Approved by Govt of
                  India and Govt of Assam since the year 2003.
                </p>
              </div>
            </div>
          </div>

          <div className="p-5">
            <div className="text-center">
              <h2> CHAIRMAN’S MESSAGE</h2>
              <h4>Sh. Ram Murti Sharma,</h4>
              <b>Chairman, PEWS Guwahati</b>
            </div>
            <div className="p-4">
              <div className="row justify-content-center">
                <p className="text-justify">
                  Prior to the starting of the academic session 2023-24, I, Sh.
                  Ram Murti Sharma, the Chairman of PEWS Guwahati (Purbanchal
                  Educational Welfare Society) Group of Institutions, would like
                  to convey some appreciable and significant achievements in the
                  academic journey of PEWS so as to make allaspiring students as
                  well as their guardians aware about how swiftly the
                  educational organization is climbing up the ladder of academic
                  accomplishment within a very short span of time. To start
                  with, Purbanchal Educational Welfare Society, a Govt.
                  Registered Society, marked its existence in the year 2003. The
                  same was constituted by certain educationists and since then,
                  the institution has strived to achieve academic excellence.
                  Motivated by its Mission of providing “A Solution For A
                  Brighter Tomorrow” and following its motto of imparting
                  quality education, PEWS Guwahati has carve a niche of its own
                  in the field of Paramedical and Nursing. The Society marched
                  forward to establishits full fledged Paramedical College named
                  “College of Physiotherapy and Medical Sciences” with
                  initialaffiliation from SNDT Womens University, Mumbai in 2005
                  to 2010, then later from Gauhati University from 2011onwards.
                  We are the pioneer to introduce Bachelor of Physiotherapy
                  (BPT) in the entire North-East region and I am delighted to
                  intimate that the tremendous response for the BPT (Bachelor of
                  Physiotherapy) Course received from students all over
                  North-East since its affiliation from Gauhati University in
                  2011has been a motivational factor for our College to thrive
                  for excellence in education.
                  <br />
                  <br />
                  Continuing its academic pursuit, the society succeeded, to
                  establish two other institutions in Nursing in the next
                  consecutive year itself, i.e., CPMS College of Nursing
                  conducting M.Sc.(N) from Srimanta Sankaradeva University of
                  Health Sciences from the session 2018-19 and B.Sc.(N) courses
                  with a permission earlier from SNDT Woman’s University, Mumbai
                  and later from Srimanta Sankaradeva University of Health
                  Sciences, and CPMS School of Nursing conducting GNM and ANM
                  courses with affiliation from Board of Examinations,
                  Directorate of Health Services, Govt. of Assam. These courses
                  are also recognized by the Indian Nursing Council, New Delhi
                  and State Nursing Council, Assam.
                  <br />
                  <br />
                  PEWS has been steadily marching towards a glorious destination
                  of academic splendor with more than 16000 students, both
                  alumni and pursuing from its different Institutions. The
                  Society has its own campus at Bonda Amgaon, Guwahati-26.
                  Another significant achievement of the Institution is its
                  facility of providing Placement in reputed organizations. PEWS
                  Global Placement Cell also has the proud privilege for being
                  the pioneer placement cell in this region for absorption of
                  Nurses and Paramedics. The formation of PEWS Global Placement
                  Cell has given placement to a number of Nursing and
                  Paramedical professional, not only from our Unit’s colleges
                  and schools but also from other educational institutes in the
                  region. This is done through Campus interviews held on behalf
                  of internationally acclaimed Health Care organizations.
                  Keeping in view its promise to provide the youngsters a
                  solution for a brighter tomorrow, the society has also
                  introduced MPT (Master of Physiotherapy), BPT (Bachelor of
                  Physiotherapy) Post Basic B.Sc. (Nursing) and other
                  Paramedical Courses like BMLT (Bachelor in Medical Laboratory
                  Technology), DMLT (Diploma in Medical Laboratory
                  Technology),Bachelor of Optometry, as well as Diploma in OT
                  Technician with an affiliation from Srimanta Sankaradeva
                  University of Health Sciences, Assam. We have an intense hope
                  that all our academic programs introduced so far will help the
                  youth community to realize their dream of higher education and
                  fulfill their cherished hopes of becoming an independent and
                  responsible individual in their own respective fields.
                </p>
              </div>
            </div>
          </div>
        </Paper>
      </div>

      <Footer />
    </>
  );
};

export default AboutUsPage;
